import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BusinessDetailComponent } from './business-detail.component';

import { ModalModule } from 'ngx-bootstrap/modal';

// ----- Material ----- //
import { MatStepperModule } from '@angular/material/stepper';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormFieldInputModule, FormFieldPasswordModule, FormFieldSelectModule, FormFieldInputMaskModule, FormFieldDateModule, ButtonsModule } from '@app/shared';

@NgModule({
  declarations: [
    BusinessDetailComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,

    MatStepperModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    FormFieldInputModule,
    FormFieldPasswordModule,
    FormFieldSelectModule,
    FormFieldInputMaskModule,
    FormFieldDateModule,
    ButtonsModule,

    ModalModule.forRoot()
  ],
  exports: [
    BusinessDetailComponent
  ]
})
export class BusinessDetailModule { }
